import { Grid } from "@mui/material";
import React from "react";
import OrdersHeader from "./home/header";
import OrdersTabel from "./home/table";

const OrdersReport = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <OrdersHeader />
      </Grid>
      <Grid item xs={12}>
        <OrdersTabel />
      </Grid>
    </Grid>
  );
};

export default OrdersReport;
